/**
 * p = player
 * r = rope length
 * b = bricks
 * s = saws (shurikens)
 * g = goals
 * h = hearts
 */
export default {
  p: { x: 400, y: 255 },
  r: 30,
  s: [],
  b: [
    { x: 272, y: 220 },
    { x: 303, y: 220 },
    { x: 333, y: 220 },
    { x: 363, y: 220 },
    { x: 393, y: 220 },
    { x: 423, y: 220 },
    { x: 453, y: 220 },
    { x: 483, y: 220 },
    { x: 453, y: 300 },
    { x: 303, y: 300 },
  ],
  g: [{ x: 368, y: 600 }],
  h: [
    { x: 550, y: 290 },
    { x: 200, y: 290 },
  ],
};
